import { lotusHealthZod } from '@lotushealth/lotushealth_js_sdk';
import { submitNativeLabOrderSet } from '@lotushealth/lotushealth_js_sdk/endpoints';
import type {
  SubmitNativeLabOrderSet200,
  SubmitNativeLabOrderSetRequestT,
} from '@lotushealth/lotushealth_js_sdk/schemas';
import { isAxiosError } from 'axios';

import { extractApiErrorDetail } from '@/shared';
import { createLotusRequestConfig } from '@/shared/api/lotus';

export type { SubmitNativeLabOrderSetRequestT };
export type SubmitNativeLabOrderSetResponseT = SubmitNativeLabOrderSet200;

export async function fetchSubmitNativeLabOrderSet(
  userId: string,
  request: SubmitNativeLabOrderSetRequestT,
  signal?: AbortSignal
): Promise<SubmitNativeLabOrderSetResponseT> {
  const config = await createLotusRequestConfig({ signal });
  let response;
  try {
    response = await submitNativeLabOrderSet(userId, request, config);
  } catch (error: unknown) {
    if (!isAxiosError(error) || error.response?.status !== 422) {
      throw error;
    }
    return {
      type: 'failure',
      reason: 'invalid_order',
      details: extractApiErrorDetail(error) ?? 'The order details are invalid.',
    };
  }
  return lotusHealthZod.submitNativeLabOrderSetResponse.parse(response.data);
}
